<!-- Режим фильтров: свой чип, клик по тексту — модалка, по кнопке — удаление -->
<p-chip *ngIf="!hasBuiltInContent" class="pa-chip-custom">
  <button 
    class="pa-chip-custom-label" 
    type="button"
    (click)="onLabelClick($event)"
    [pTooltip]="isTruncated ? label : null"
    tooltipPosition="top">
    {{ displayLabel }}
  </button>
  <button
    *ngIf="removable"
    class="pa-chip-custom-remove"
    (click)="onRemoveClick($event)"
  >
    <i class="pi pi-times-circle"></i>
  </button>
</p-chip>

<!-- Режим ui-kit: с иконкой/картинкой -->
<p-chip
  *ngIf="hasBuiltInContent"
  class="pa-chip-host"
  [label]="displayLabel"
  [icon]="icon"
  [image]="image"
  [removable]="removable"
  [styleClass]="styleClass"
  [style]="style"
  [pTooltip]="isTruncated ? label : null"
  tooltipPosition="top"
  (onRemove)="onRemoveClick()"
></p-chip>
